import React, { useEffect } from 'react'
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-dark.png";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Link, useNavigate } from "react-router-dom";
import { Alert, Card, CardBody, Col, Container, Form, FormFeedback, Input, Label, Row } from 'reactstrap';

const Register = props => {
  //meta title
  document.title = "Inscription | Rakops Solutions";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      first_name: '',
      last_name: '',
      company_name: '',
      password: '',
      password_confirmation: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Veuillez saisir votre email"),
      first_name: Yup.string().required("Veuillez saisir votre prénom"),
      last_name: Yup.string().required("Veuillez saisir votre nom"),
      company_name: Yup.string().required("Veuillez saisir le nom de votre entreprise"),
      password: Yup.string().required("Veuillez saisir votre mot de passe"),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Les mots de passe doivent correspondre')
        .required("Veuillez confirmer votre mot de passe"),
    }),
    onSubmit: (values) => {
      dispatch(registerUser(values));
    }
  });

  const selectAccountState = (state) => state.Account;
  const AccountProperties = createSelector(
    selectAccountState,
    (account) => ({
      user: account.user,
      registrationError: account.registrationError,
      success: account.success
    })
  );

  const {
    user,
    registrationError, success
  } = useSelector(AccountProperties);

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  useEffect(() => {
    success && setTimeout(() => navigate("/login"), 2000)
  }, [success, navigate])

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={8} xl={6}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">Inscription gratuite</h4>
                    <p className="text-muted text-center">Profitez de votre essai gratuit de 14 jours maintenant.</p>
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {success && (
                        <Alert color="success">
                          Utilisateur inscrit avec succès ! Redirection vers la page de connexion...
                        </Alert>
                      )}

                      {registrationError && (
                        <Alert color="danger">{registrationError}</Alert>
                      )}

                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label>Prénom</Label>
                            <Input
                              name="first_name"
                              type="text"
                              placeholder="Saisir votre prénom"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.first_name || ""}
                              invalid={validation.touched.first_name && validation.errors.first_name ? true : false}
                            />
                            {validation.touched.first_name && validation.errors.first_name ? (
                              <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label>Nom</Label>
                            <Input
                              name="last_name"
                              type="text"
                              placeholder="Saisir votre nom"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.last_name || ""}
                              invalid={validation.touched.last_name && validation.errors.last_name ? true : false}
                            />
                            {validation.touched.last_name && validation.errors.last_name ? (
                              <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      <div className="mb-3">
                        <Label>Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Saisir votre email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={validation.touched.email && validation.errors.email ? true : false}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label>Nom de l'entreprise</Label>
                        <Input
                          name="company_name"
                          type="text"
                          placeholder="Saisir le nom de l'entreprise"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.company_name || ""}
                          invalid={validation.touched.company_name && validation.errors.company_name ? true : false}
                        />
                        {validation.touched.company_name && validation.errors.company_name ? (
                          <FormFeedback type="invalid">{validation.errors.company_name}</FormFeedback>
                        ) : null}
                      </div>

                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label>Mot de passe</Label>
                            <Input
                              name="password"
                              type="password"
                              placeholder="Saisir votre mot de passe"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password || ""}
                              invalid={validation.touched.password && validation.errors.password ? true : false}
                            />
                            {validation.touched.password && validation.errors.password ? (
                              <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label>Confirmer le mot de passe</Label>
                            <Input
                              name="password_confirmation"
                              type="password"
                              placeholder="Confirmer le mot de passe"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password_confirmation || ""}
                              invalid={validation.touched.password_confirmation && validation.errors.password_confirmation ? true : false}
                            />
                            {validation.touched.password_confirmation && validation.errors.password_confirmation ? (
                              <FormFeedback type="invalid">{validation.errors.password_confirmation}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      <div className="mb-3 row mt-4">
                        <div className="col-12 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Créer un compte</button>
                        </div>
                      </div>

                      <div className="mb-0 row">
                        <div className="col-12 mt-4">
                          <p className="text-muted mb-0 font-size-14">En vous inscrivant, vous acceptez les <Link to="#" className="text-primary">Conditions d'utilisation</Link> de Rakops Solutions</p>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>Vous avez déjà un compte ? <Link to="/login" className="text-primary"> Se connecter </Link> </p>
                © {new Date().getFullYear()} Rakops Solutions. Tous droits réservés. <span className="d-none d-sm-inline-block"> Construit avec passion.</span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

export default Register
